import { Box, Typography } from "@mui/material";
import { memo, useMemo } from "react";
import {
  isHtmlDescription,
  sanitizeReportDescription,
} from "./reportDescriptionHtml";

interface IReportDescriptionContentProps {
  description: string;
}

const ReportDescriptionContentComponent: React.FC<
  IReportDescriptionContentProps
> = ({ description }) => {
  const sanitizedHtml = useMemo(
    () =>
      isHtmlDescription(description)
        ? sanitizeReportDescription(description)
        : null,
    [description],
  );

  if (sanitizedHtml === null) {
    return (
      <Typography variant="body2" sx={{ whiteSpace: "pre-line" }}>
        {description}
      </Typography>
    );
  }

  return (
    <Box
      sx={{
        fontSize: "0.875rem",
        "& p": { m: 0 },
        "& p + p": { mt: 0.5 },
        "& ul, & ol": { my: 0.5, pl: 2.5 },
        "& a": { color: "inherit", textDecoration: "underline" },
      }}
      dangerouslySetInnerHTML={{ __html: sanitizedHtml }}
    />
  );
};

export const ReportDescriptionContent = memo(ReportDescriptionContentComponent);
